import React, { memo, useEffect } from "react";
import { validators, formats } from "investira.sdk";
import { Stack, Divider, Typography } from "investira.react.components";
import ConsultaProvider from "../../../../contexts/ConsultaContext";
import useKickBack from "../../../../hooks/useKickBack";
import withMessage from "../../../../hoc/withMessage";
import PlanoPosicao from "../PlanoPosicao";
import DetalhesErrorMessage from "../DetalhesErrorMessage";
import Highlights from "./Highlights";
import Graphs from "./Graphs";
import Secoes from "./Secoes";

const ConsultaConferenciaCustodiante = memo((props) => {
  const { data } = props;
  const kick = useKickBack();

  const xQuantidadeTolerancia =
    data.request_metadata?.custodiante_conferencia_quantidade_tolerancia || 0;

  const ativosFiltered = (
    ativos = [],
    filtrarComErro = false,
    atributoErro = "erros",
  ) => {
    if (!Array.isArray(ativos)) return [];

    return ativos.filter((ativo) =>
      filtrarComErro
        ? ativo.hasOwnProperty(atributoErro)
        : !ativo.hasOwnProperty(atributoErro),
    );
  };

  useEffect(() => {
    kick && props.onMessage("Entidade alterada");
  }, [kick]);

  if (validators.isEmpty(data)) {
    return null;
  }

  const xAtivosError = ativosFiltered(data.response.detalhe, true);
  const xAtivosErrorSize = xAtivosError.length;
  const hasError = xAtivosErrorSize > 0;

  return (
    <ConsultaProvider>
      <Stack spacing={2}>
        <PlanoPosicao
          beta={true}
          created={data.request?.data}
          carteira={data.request_metadata?.carteira}
        />
        <Divider />

        <DetalhesErrorMessage show={hasError} ativosSize={xAtivosErrorSize} />
        <Stack
          sx={{ gap: 2, mb: 1 }}
          component="section"
          direction={{ xs: "column", md: "row" }}
        >
          <Highlights data={data} />
        </Stack>
        <Stack component="section">
          <Graphs data={data} />
        </Stack>
        <Stack>
          {xQuantidadeTolerancia > 0 && (
            <Stack my={2}>
              <Typography variant="caption" color="textSecondary">
                Também serão ignorados ativos que possuem divergências de
                quantidade menores ou iguais a{" "}
                <b>
                  {formats.formatNumber(xQuantidadeTolerancia, 6, true, false)}
                </b>
                .
              </Typography>
            </Stack>
          )}
        </Stack>
        <Stack>
          <Secoes data={data} />
        </Stack>
      </Stack>
    </ConsultaProvider>
  );
});

export default withMessage(ConsultaConferenciaCustodiante);
